import React from "react";
import { useNavigate } from "react-router-dom";
import { MapPin, Award } from "lucide-react";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { useApp } from "@/context/AppContext";

const livingBadge = (pref, t) => {
  if (pref === "family") return { label: `👨‍👩‍👦 ${t("with_family")}`, cls: "bg-rose-100 text-rose-800 border-rose-300" };
  if (pref === "bachelor") return { label: `🧘 ${t("bachelor")}`, cls: "bg-sky-100 text-sky-800 border-sky-300" };
  return { label: `🕉️ ${t("open_both")}`, cls: "bg-emerald-100 text-emerald-800 border-emerald-300" };
};

export default function ArchakaCard({ archaka }) {
  const { t } = useApp();
  const nav = useNavigate();
  const lb = livingBadge(archaka.living_preference, t);

  return (
    <Card data-testid={`archaka-card-${archaka.id}`} className="p-4 bg-surface gold-border temple-shadow hover:-translate-y-1 transition-transform duration-300 rounded-2xl">
      <div className="flex items-start gap-3">
        <Avatar className="w-16 h-16 border-2 border-goldline/50">
          <AvatarImage src={archaka.photo} />
          <AvatarFallback className="bg-maroon text-marigold text-lg">{(archaka.name || "అ").slice(0, 2)}</AvatarFallback>
        </Avatar>
        <div className="flex-1 min-w-0">
          <h3 className="font-serifte font-bold text-maroon text-base leading-tight line-clamp-1">{archaka.name}</h3>
          <p className="text-xs text-muted-foreground font-telugu flex items-center gap-1"><MapPin className="w-3 h-3 text-saffron" />{archaka.district}</p>
          <Badge className={`mt-1 border ${lb.cls} font-telugu text-[10px]`}>{lb.label}</Badge>
        </div>
      </div>

      <div className="mt-3 p-2.5 rounded-xl lineage-badge font-telugu text-[12px] leading-relaxed">
        🪷 <b>గోత్రం:</b> {archaka.gotram} {archaka.shakha ? <> | <b>శాఖ:</b> {archaka.shakha}</> : null}
      </div>

      <div className="mt-2 flex flex-wrap gap-1.5">
        {archaka.agama && <Badge variant="outline" className="border-goldline/50 text-maroon font-telugu text-[11px]">{archaka.agama}</Badge>}
        {archaka.experience_years ? <Badge variant="outline" className="border-goldline/50 text-maroon font-telugu text-[11px]"><Award className="w-3 h-3 mr-0.5" />{archaka.experience_years} {t("years")}</Badge> : null}
      </div>

      <Button data-testid={`archaka-view-${archaka.id}`} onClick={() => nav(`/archakas/${archaka.id}`)} className="w-full mt-3 btn-sacred border-0 font-telugu">
        {t("view_details")}
      </Button>
    </Card>
  );
}
